import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=47aa12d3&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aa12d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/recommendations/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47aa12d3')) {
      api.createRecord('47aa12d3', component.options)
    } else {
      api.reload('47aa12d3', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=47aa12d3&scoped=true&", function () {
      api.rerender('47aa12d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings.vue"
export default component.exports